import React from 'react';
import { DropDown } from '../../../../common/dropdown';
import { connect } from 'react-redux';
import { REDUCER_NAME, changeIndex } from './../../reducer';
import Const from './../../Const';

const mapStateToProps = state => {
  return {
    currentDefaultIndex: state[REDUCER_NAME].currentDefaultIndex,
    listDefaultIndex: state[REDUCER_NAME].listDefaultIndex,
    listDefaultIndexByKey: state[REDUCER_NAME].listDefaultIndexByKey,
    watchListId: state[REDUCER_NAME].watchListId,
  };
};

const mapDispatchToProps = {
  changeIndex,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(FilterCompanyGroup);

function FilterCompanyGroup({
  watchListId,
  listDefaultIndex,
  listDefaultIndexByKey,
  currentDefaultIndex,
  changeIndex,
}) {
  return (
    <DropDown
      id={watchListId}
      keyTitle="text"
      listKey={listDefaultIndex}
      listDataByKey={listDefaultIndexByKey}
      currentKey={currentDefaultIndex}
      change={changeIndex}
      keyShowTooltip={Const.companyGroupShowTooltip}
      tooltipText="watchListSummary.tooltipItemCompanyGroup"
    />
  );
}
